import React from 'react';

import './skeleton-box.scss';

function SkeletonBox() {
  return (
    <div className="skeleton-box image" />
  );
}

export default SkeletonBox;
